import { combineReducers } from 'redux'
import { t } from 'ttag'
import { formReducer, modelReducer } from 'react-redux-form'

import location from './budget/location'
import listing from './budget/listing'
import reverseWage from './budget/reverseWage'

import * as actions from '../../actions/assessments/budget'
import { BUDGET_RESULTS } from '../../actions/assessments/budget'
import * as h2Api from '../../h2Api'

const initialSavedConfirm = {
  visible: false,
  forUser: null
}
const initialState = {
  rounds: [
    {
      name: () => t`Housing `,
      roundId: 0,
      id: 'housing',
      visibleMenu: true
    },
    {
      name: () => t`Utilities`,
      roundId: 1,
      id: 'utility',
      visibleMenu: true
    },
    {
      name: () => t`Food`,
      roundId: 2,
      id: 'food',
      visibleMenu: true
    },
    {
      name: () => t`Entertainment`,
      roundId: 3,
      id: 'entertainment',
      visibleMenu: true
    },
    {
      name: () => t`Clothes`,
      roundId: 4,
      id: 'clothes',
      visibleMenu: true
    },
    {
      name: () => t`Transport`,
      roundId: 5,
      id: 'transportation',
      visibleMenu: true
    },
    {
      name: () => t`Insurance`,
      roundId: 6,
      id: 'healthinsurance',
      visibleMenu: true
    },
    {
      name: () => t`Education`,
      roundId: 7,
      id: 'education',
      visibleMenu: true
    },
    {
      name: () => t`Savings`,
      roundId: 8,
      id: 'savings',
      visibleMenu: true
    },
    {
      name: () => t`Other`,
      roundId: 9,
      id: 'other',
      visibleMenu: false
    }
  ],
  showSavedConfirm: initialSavedConfirm,
  ...h2Api.handleRest()
}
const initialEditForm = {
  expenseName: '',
  monthlyCost: 0,
  description: ''
}
const main = (state = initialState, action) => {
  switch (action.type) {
    case actions.BUDGET_SAVE_PORTFOLIO:
      return {
        ...state,
        showSavedConfirm: {
          visible: true,
          forUser: action.user ? action.user.name : null
        }
      }

    case actions.BUDGET_SAVE_PORTFOLIO_DISMISS:
      return {
        ...state,
        showSavedConfirm: {
          visible: false
        }
      }

    case actions.UPDATE_ACTIVE_ROUND:
      const r = {
        ...state,
        result: {
          ...state.result,
          currentRound: action.roundId
        }
      }

      console.log(r)

      return r

    case actions.BUDGET_APPEND_REPLACE_RESPONSE:
      console.log(action)

      return {
        ...state,
        result: {
          ...state.result,
          responses: [
            ...state.result.responses.filter(r => {
              if (action.response > 0) {
                return r.id !== action.response.id
              }

              return r.round !== action.response.round
            }),
            action.response
          ]
        }
      }

    case actions.SELECT_BUDGET:
      return {
        ...state,
        ...h2Api.handleRest(action)
      }

    default:
      return state
  }
}

export default combineReducers({
  main,
  listing,
  reverseWage,
  location,
  budgetResultsResponse: h2Api.restReducer(BUDGET_RESULTS),
  customOptionForm: modelReducer('assessments.budget.customOptionForm', initialEditForm),
  forms: formReducer('assessments.budget', {
    customOptionForm: initialEditForm
  })
})
